import { useBuild, useJobsForStep } from "~/components/build/Show/lib/BuildContext";
import { TriggerJob } from "~/components/build/Show/lib/types";
import TriggerJobSummary from "~/components/build/Show/components/TriggerJobSummary";
import Button from "~/components/shared/Button";

interface Props {
  job: TriggerJob;
}

export const TriggerJobDetails = ({ job }: Props) => {
  const { build } = useBuild();

  const jobs = useJobsForStep<TriggerJob>(job.stepUuid);
  // eslint-disable-next-line id-length
  const isRetry = Boolean(jobs.find((j) => j.retriedInJobUuid === job.id));

  return (
    <div className="job-list-pipeline flex h-full flex-col">
      <TriggerJobSummary job={job} isRetry={isRetry} build={build} />

      {job.triggeredBuild && job.triggeredBuild.streamName && !job.triggeredBuild.destroyedAt && (
        <>
          <div className="border-gray rounded-b bg-slate-100/70 p-3 shadow-inner">
            <turbo-cable-stream-source
              signed-stream-name={job.triggeredBuild.streamName}
              channel="Turbo::StreamsChannel"
            />
            <div id={job.triggeredBuild.streamTargetDomId}>
              <turbo-frame
                id={job.triggeredBuild.stepsStreamDomId}
                src={job.triggeredBuild.stepsUrl}
              >
                <div>Loading steps...</div>
              </turbo-frame>
            </div>
          </div>

          <div className="mt-3 px-2.5">
            <Button href={job.triggeredBuild.url} theme="small" target="_blank">
              <span className="after:ml-1 after:content-['→']">Go to build</span>
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
